export const getTokenFromResponseV2 = (response) => {
    const parsedResponse = JSON.parse(response);
    if (!parsedResponse.token) {
        throw new Error("Token is not available");
    }
    return parsedResponse.token;
};
//# sourceMappingURL=GetTokenFromResponseV2.js.map